import { api } from "@/lib/api";

export type McpPermission =
	| "projects:read"
	| "tasks:read"
	| "tasks:write"
	| "tickets:read"
	| "tickets:write"
	| "comments:read"
	| "comments:write";

export type McpClient = "claude" | "codex" | "cursor" | "other";

export interface McpConnection {
	id: string;
	name: string;
	client: McpClient;
	token_prefix: string;
	permissions: McpPermission[];
	/** Empty = every project the owner is a member of. */
	project_ids: string[];
	expires_at: string | null;
	last_used_at: string | null;
	last_used_ip: string | null;
	revoked_at: string | null;
	created_at: string;
}

export interface CreatedMcpConnection extends McpConnection {
	token: string;
}

export interface McpConnectionPayload {
	name: string;
	permissions: McpPermission[];
	project_ids: string[];
	client?: McpClient;
	expires_at?: string | null;
}

export interface McpTool {
	name: string;
	description: string;
	permission: McpPermission | null;
	inputSchema: {
		properties?: Record<string, { type?: string; description?: string; enum?: string[] }>;
		required?: string[];
	};
}

const API_URL = import.meta.env.VITE_API_URL ?? "http://localhost:5050";

export const MCP_URL = `${API_URL}/mcp`;

export async function listMcpConnections(): Promise<McpConnection[]> {
	const res = await api.get<{ data: McpConnection[] }>("/mcp-connections");
	return res.data;
}

export async function createMcpConnection(
	payload: McpConnectionPayload,
): Promise<CreatedMcpConnection> {
	const res = await api.post<{ data: CreatedMcpConnection }>("/mcp-connections", payload);
	return res.data;
}

export async function updateMcpConnection(
	id: string,
	payload: Pick<McpConnectionPayload, "name" | "permissions" | "project_ids">,
): Promise<McpConnection> {
	const res = await api.patch<{ data: McpConnection }>(`/mcp-connections/${id}`, payload);
	return res.data;
}

export async function revokeMcpConnection(id: string): Promise<void> {
	await api.delete(`/mcp-connections/${id}`);
}

export async function getMcpToolCatalog(): Promise<McpTool[]> {
	const res = await api.get<{ data: { tools: McpTool[] } }>("/mcp/tools");
	return res.data.tools;
}
